import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FieldValue from 'app/components/bibs/shared/MetadataDisplay/FieldValue';
import { ExpandableList } from '@bibliocommons/expandable';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibMetadataEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import './Contains.scss';

const MAX_ITEMS_DISPLAYED = 3;

const { composeMetadataLinkClickEvent } = bibMetadataEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

function handleClickEvent() {
  sendAnalyticsEvents(
    composeMetadataLinkClickEvent({
      fieldName: 'CONTAINS_WORK',
      category: 'CONTAINS',
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ABOUT
    })
  );
}

export default function Contains({ containedWork }) {
  if (!containedWork || !containedWork.size) return null;

  function renderItems() {
    const renderWork = work => <FieldValue value={work} handleClick={handleClickEvent} />;
    const getItemKey = item => item.getIn(['primary', 'values', 0]);

    return (
      <ExpandableList
        list={containedWork}
        getItemKey={getItemKey}
        renderItem={renderWork}
        collapseCount={MAX_ITEMS_DISPLAYED}
        expandLinkHref="#show-more-contains"
        stacked
        textKey="contains"
      />
    );
  }

  return (
    <div className="cp-contains">
      <FormattedMessage tagName="h3" id="bib_metadata_category_contains" />
      {renderItems()}
    </div>
  );
}

Contains.propTypes = {
  containedWork: ImmutablePropTypes.listOf(ImmutablePropTypes.map)
};
